import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyBearMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#f6efe6" />
      <circle cx={397} cy={460} r={140} fill="#8b5a3c" />
      <g className="mode-copy" transform="translate(48,840)" fill="#111"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyBearMode;
